<template>
  <div class="w-100 px-3">
    <div 
      v-for="(room, roomIndex) in rooms" 
      :id="`room-cart-${room.room_rate.id}-${room.guestIndex}`"
      :class="{
        'mb-4 pb-4 border-b-form': roomIndex+1 < rooms.length,
        'pb-4' : $is_mobile_view
      }"
      >
      <div class="d-flex align-items-top justify-content-between">
        <div>
          <p class="w-100 mb-1 body-2-4 cursor-pointer lh-1-2">{{room.display.name}}</p>
          <div class="d-flex align-items-center">
            <svg width="18" height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M4.61635 6.47797C5.78613 6.47797 6.80503 5.4214 6.80503 4.0566C6.80503 2.69811 5.77985 1.7044 4.61635 1.7044C3.44654 1.7044 2.42138 2.72327 2.42138 4.06918C2.42138 5.4214 3.44025 6.47797 4.61635 6.47797ZM1.10692 12.1572H8.1132C8.91196 12.1572 9.22012 11.8427 9.22012 11.2704C9.22012 9.53457 7.44653 7.44025 4.61006 7.44025C1.77358 7.44025 0 9.53457 0 11.2704C0 11.8427 0.314465 12.1572 1.10692 12.1572Z"
                fill="#777" />
              <path
                d="M7.89937 13.0126H15.805C17.4591 13.0126 18 12.2138 18 11.3208C18 9.20751 15.5786 6.60378 11.849 6.60378C8.12575 6.60378 5.70438 9.20751 5.70438 11.3208C5.70438 12.2138 6.24525 13.0126 7.89937 13.0126Z"
                fill="white" />
              <path
                d="M11.8553 6.33334C13.2076 6.33334 14.371 5.12578 14.371 3.55346C14.371 2 13.2013 0.84906 11.8553 0.84906C10.5094 0.84906 9.33961 2.02516 9.33961 3.56604C9.33961 5.12578 10.5031 6.33334 11.8553 6.33334ZM7.89941 12.1572H15.805C16.7925 12.1572 17.1446 11.8742 17.1446 11.3208C17.1446 9.6981 15.1132 7.4591 11.849 7.4591C8.5912 7.4591 6.55978 9.6981 6.55978 11.3208C6.55978 11.8742 6.91196 12.1572 7.89941 12.1572Z"
                fill="#777" />
            </svg>
            <span class="body-3-1 ml-1">{{ room.display.guestText }}</span>
          </div>
          <div class="d-flex align-items-center mt-1" v-if="$isNotEmptyV2(room.room_rate.cancellation_policy)">
            <svg width="18" height="18" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1197_36)">
                <path
                  d="M3.67969 25.4062H19.6875C22.1367 25.4062 23.3555 24.1875 23.3555 21.7734V7.46484C23.3555 5.05078 22.1367 3.83203 19.6875 3.83203H3.67969C1.23047 3.83203 0 5.03906 0 7.46484V21.7734C0 24.1992 1.23047 25.4062 3.67969 25.4062ZM3.50391 23.5195C2.46094 23.5195 1.88672 22.9688 1.88672 21.8789V10.8281C1.88672 9.75 2.46094 9.1875 3.50391 9.1875H19.8398C20.8828 9.1875 21.4688 9.75 21.4688 10.8281V21.8789C21.4688 22.9688 20.8828 23.5195 19.8398 23.5195H3.50391Z"
                  fill="#777777" />
                <path
                  d="M9.39844 13.3945H10.0898C10.5 13.3945 10.6289 13.2773 10.6289 12.8672V12.1758C10.6289 11.7656 10.5 11.6367 10.0898 11.6367H9.39844C8.98828 11.6367 8.84766 11.7656 8.84766 12.1758V12.8672C8.84766 13.2773 8.98828 13.3945 9.39844 13.3945ZM13.2891 13.3945H13.9805C14.3906 13.3945 14.5312 13.2773 14.5312 12.8672V12.1758C14.5312 11.7656 14.3906 11.6367 13.9805 11.6367H13.2891C12.8789 11.6367 12.7383 11.7656 12.7383 12.1758V12.8672C12.7383 13.2773 12.8789 13.3945 13.2891 13.3945ZM17.1797 13.3945H17.8711C18.2812 13.3945 18.4219 13.2773 18.4219 12.8672V12.1758C18.4219 11.7656 18.2812 11.6367 17.8711 11.6367H17.1797C16.7695 11.6367 16.6406 11.7656 16.6406 12.1758V12.8672C16.6406 13.2773 16.7695 13.3945 17.1797 13.3945ZM5.50781 17.2266H6.1875C6.60938 17.2266 6.73828 17.1094 6.73828 16.6992V16.0078C6.73828 15.5977 6.60938 15.4805 6.1875 15.4805H5.50781C5.08594 15.4805 4.95703 15.5977 4.95703 16.0078V16.6992C4.95703 17.1094 5.08594 17.2266 5.50781 17.2266ZM9.39844 17.2266H10.0898C10.5 17.2266 10.6289 17.1094 10.6289 16.6992V16.0078C10.6289 15.5977 10.5 15.4805 10.0898 15.4805H9.39844C8.98828 15.4805 8.84766 15.5977 8.84766 16.0078V16.6992C8.84766 17.1094 8.98828 17.2266 9.39844 17.2266ZM13.2891 17.2266H13.9805C14.3906 17.2266 14.5312 17.1094 14.5312 16.6992V16.0078C14.5312 15.5977 14.3906 15.4805 13.9805 15.4805H13.2891C12.8789 15.4805 12.7383 15.5977 12.7383 16.0078V16.6992C12.7383 17.1094 12.8789 17.2266 13.2891 17.2266ZM5.50781 21.0703H6.1875C6.60938 21.0703 6.73828 20.9414 6.73828 20.5312V19.8398C6.73828 19.4297 6.60938 19.3125 6.1875 19.3125H5.50781C5.08594 19.3125 4.95703 19.4297 4.95703 19.8398V20.5312C4.95703 20.9414 5.08594 21.0703 5.50781 21.0703ZM9.39844 21.0703H10.0898C10.5 21.0703 10.6289 20.9414 10.6289 20.5312V19.8398C10.6289 19.4297 10.5 19.3125 10.0898 19.3125H9.39844C8.98828 19.3125 8.84766 19.4297 8.84766 19.8398V20.5312C8.84766 20.9414 8.98828 21.0703 9.39844 21.0703ZM13.2891 21.0703H13.9805C14.3906 21.0703 14.5312 20.9414 14.5312 20.5312V19.8398C14.5312 19.4297 14.3906 19.3125 13.9805 19.3125H13.2891C12.8789 19.3125 12.7383 19.4297 12.7383 19.8398V20.5312C12.7383 20.9414 12.8789 21.0703 13.2891 21.0703Z"
                  fill="#777777" />
                <path
                  d="M22.4297 29.2148C26.543 29.2148 29.9766 25.7812 29.9766 21.6562C29.9766 17.5078 26.5781 14.0977 22.4297 14.0977C18.2812 14.0977 14.8711 17.5195 14.8711 21.6562C14.8711 25.8164 18.2695 29.2148 22.4297 29.2148Z"
                  fill="white" />
                <path
                  d="M22.4297 27.6094C25.6523 27.6094 28.3828 24.9141 28.3828 21.6562C28.3828 18.3867 25.6875 15.7031 22.4297 15.7031C19.1602 15.7031 16.4766 18.3984 16.4766 21.6562C16.4766 24.9375 19.1602 27.6094 22.4297 27.6094Z"
                  fill="#777777" />
                <path
                  d="M19.6523 22.5703C19.2422 22.5703 18.9141 22.2422 18.9141 21.8438C18.9141 21.457 19.2539 21.1289 19.6523 21.1289H21.7617V18.1875C21.7617 17.8008 22.0898 17.4844 22.4883 17.4844C22.8867 17.4844 23.2148 17.8008 23.2148 18.1875V21.8438C23.2148 22.2539 22.8984 22.5703 22.4883 22.5703H19.6523Z"
                  fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_1197_36">
                  <rect width="29.9766" height="29.2148" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <span class="body-3 text-green ml-1 mr-2">{{ room.room_rate.cancellation_policy.title }}</span>
            <template v-if="$isNotEmptyV2(room.room_rate.cancellation_policy.description)">
              <svg :id="`cencellation_policy_${roomIndex}`" class="cursor-help" width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8 15.9921C12.3765 15.9921 16 12.3626 16 7.99605C16 3.62175 12.3687 0 7.99217 0C3.62354 0 0 3.62175 0 7.99605C0 12.3626 3.63138 15.9921 8 15.9921ZM8 14.6595C4.29805 14.6595 1.34118 11.6962 1.34118 7.99605C1.34118 4.29593 4.29021 1.33268 7.99217 1.33268C11.6942 1.33268 14.6667 4.29593 14.6667 7.99605C14.6667 11.6962 11.702 14.6595 8 14.6595Z"
                  fill="#777" />
                <path
                  d="M6.62746 12.3861H9.81964C10.1412 12.3861 10.3921 12.1509 10.3921 11.8295C10.3921 11.5238 10.1412 11.2808 9.81964 11.2808H8.84711V7.29053C8.84711 6.86721 8.63528 6.58501 8.23532 6.58501H6.76082C6.43922 6.58501 6.18824 6.82801 6.18824 7.13379C6.18824 7.45515 6.43922 7.69036 6.76082 7.69036H7.60004V11.2808H6.62746C6.3059 11.2808 6.05492 11.5238 6.05492 11.8295C6.05492 12.1509 6.3059 12.3861 6.62746 12.3861ZM7.92946 5.28369C8.50196 5.28369 8.94904 4.82901 8.94904 4.25675C8.94904 3.68448 8.50196 3.2298 7.92946 3.2298C7.36472 3.2298 6.9098 3.68448 6.9098 4.25675C6.9098 4.82901 7.36472 5.28369 7.92946 5.28369Z"
                  fill="#777" />
              </svg>
              <b-tooltip :target="`cencellation_policy_${roomIndex}`" placement="bottom">
                <div class="html-desc" v-html="room.room_rate.cancellation_policy.description"></div>
              </b-tooltip>
            </template>
          </div>
        </div>
        <div class="lh-1 text-right flex-shrink-0" >
          <div class="w-100 mb-2">
            <p v-if="room.display.price.promotion < 0" class="mb-0 text-12 text-subcolor font-lato-regular text-line-through mb-1">{{$formatCurrency(room.display.price.subtotal)}}</p>
            <p class="mb-0 text-14 font-lato cursor-pointer text-orange">{{$formatCurrency(room.display.price.final)}}</p>
          </div>
          <p @click="manageGuest(room.roomIndex, room.guestIndex)" class="font-lato text-green text-12 underline mb-2 cursor-pointer" style="text-underline-offset: 2px;">Manage Guest</p>
          <p @click="removeReservation(room)" class="font-lato text-danger text-12 underline mb-0 cursor-pointer" style="text-underline-offset: 2px;">Remove Room</p>
        </div>
      </div>
      <div v-if="$isNotEmptyV2(room.product)" class="w-100 mt-3 pb-3 box-shadow-main rounded-4 border-form">
        <div class="d-flex align-items-center bg-light border-b-form bg-light-page px-2-5 py-2 mb-2 rounded-top-4">
          <svg height="18" viewBox="0 0 40 45" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.14628 35.2054L1.64404 40.3013C1.9227 41.1824 2.28843 41.8216 2.77608 42.288L5.04015 40.8196C4.43058 40.5777 4.03002 40.0941 3.80362 39.2995L2.63675 35.0154C2.54968 34.739 2.65417 34.549 2.95024 34.549H36.737C37.033 34.549 37.1201 34.7909 36.9112 35.0154L33.1494 39.2821C32.5572 39.9387 32.087 40.4915 31.0421 40.7851L33.1668 42.3399C34.0725 41.7179 34.769 40.8541 35.6747 39.8349L39.4365 35.5509C40.6731 34.1171 39.7674 32.1997 37.7645 32.1997H2.3581C0.459766 32.1997 -0.35878 33.4779 0.14628 35.2054ZM16.7262 33.6507H19.0773V1.17467C19.0773 0.535509 18.5374 0 17.893 0C17.2486 0 16.7262 0.535509 16.7262 1.17467V33.6507ZM18.0672 27.7083H25.2251C30.4674 27.7083 33.3758 25.048 33.3758 20.7466C33.3758 13.4223 25.7129 5.18234 18.5723 1.4856L17.3706 3.50673C23.2919 6.06335 31.0247 13.7332 31.0247 20.3839C31.0247 23.3897 28.8999 25.3589 25.2425 25.3589H18.0672V27.7083ZM19.5302 4.59502C25.3122 12.8177 23.4487 22.8197 17.9801 25.5663L18.4679 27.6047C25.9392 24.2016 27.7156 13.4568 21.5504 4.24952L19.5302 4.59502ZM4.36093 27.7083H17.6319V25.3589H6.62498C6.416 25.3589 6.32891 25.1517 6.50307 25.0308C12.4593 20.5739 17.9627 10.3129 18.8684 3.28215L16.7262 1.81382C16.8655 7.63533 11.3795 18.7083 3.38564 24.4608C1.6963 25.6872 2.63675 27.7083 4.36093 27.7083ZM18.4503 44.1536C23.1874 44.1536 23.9538 40.6469 26.7055 40.6469C29.5443 40.6469 29.9971 44.1536 35.4308 44.1536H37.1898C37.869 44.1536 38.4263 43.6008 38.4263 42.9271C38.4263 42.2535 37.869 41.7179 37.1898 41.7179H35.4308C33.5499 41.7179 32.505 40.9405 31.1813 40.0249C30.0493 39.2132 28.6386 38.2112 26.7055 38.2112C24.7201 38.2112 23.2919 39.2649 22.1425 40.1113C20.9582 41.0096 20.0004 41.7179 18.4503 41.7179C16.8829 41.7179 15.925 41.0096 14.7408 40.1113C13.5913 39.2649 12.1632 38.2112 10.1778 38.2112C8.24467 38.2112 6.83398 39.2132 5.70194 40.0249C4.37833 40.9405 3.33339 41.7179 1.45247 41.7179H1.36539C0.686172 41.7179 0.14628 42.2535 0.14628 42.9271C0.14628 43.6008 0.686172 44.1536 1.36539 44.1536H1.45247C6.88622 44.1536 7.33903 40.6469 10.1778 40.6469C12.9295 40.6469 13.6958 44.1536 18.4503 44.1536Z" fill="#777"/>
          </svg>
          <p class="mb-0 body-2-1 ml-2">Transport</p>
        </div>
        
        <template v-for="(routeType,routeTypeIndex) in room.product">
          <PerRoomCartProduct 
            ref="transportPerRoute"
            @refreshRef="registerRef"
            :route-type="routeType"
            :room-id="room.room_rate.id"
            :guest-index="room.guestIndex"
          />
          <div v-if="routeTypeIndex + 1 < room.product.length" class="my-2 border-b-form-dashed w-100"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import PerRoomCartProduct from './PerRoomCartProduct.vue';

  export default {
    components:{
      PerRoomCartProduct
    },
    computed:{
      ...mapGetters(['getBeCart']),
      rooms(){
        let rooms = [];

        const savedRooms = this.getBeCart.room_rate_details;

        savedRooms.forEach((room, roomIndex) => {
          const { room_rate, qty, guest } = room;

          for (let i = 0; i < qty; i++) {
            if(this.$isNotEmptyV2(guest[i])){
              const { products = [] } = guest[i];
              
              rooms.push({
                room_rate,
                guest: guest[i],
                guestIndex: i,
                roomIndex,
                roomQty: qty,
                product: this.filterProductByRouteType(products),
                display: this.roomConfig(room_rate, guest[i])
              })
            }
          }
        });
        
        return rooms;
      }
    },
    mounted(){
      this.registerRef();
    },
    methods:{
      ...mapMutations(['BeRemoveReservation', 'changeBeRoomAvbl']),
      registerRef(){
        const refList = this.$refs.transportPerRoute ? this.$refs.transportPerRoute : []; 
        this.$emit('register-tr-ref', refList);
      },
      roomConfig(roomRate, guest){
        const { name, room_type: { image }, dates } = roomRate
        
        const thumbnail = this.$isEmpty(image) ? this.getMerchant.image_url : image[0].image_url
        
        return {
          name,
          thumbnail,
          price: this.generatePrice(dates, guest),
          guestText: this.generateGuest(guest)
        }
      },
      generatePrice(dates, guest){
        let subtotal = 0;
        let final = 0;
        let promotion = 0;
        
        for(let date of dates){
          const { extra_guest, 
            price: pricePerDate, 
            promotion_price: promotionPricePerDate 
          } = date;
          
          let total_extra = {
            adult: guest.extra.adult*extra_guest.adult.amount,
            child: guest.extra.child*extra_guest.child.amount,
            infant: guest.extra.infant*extra_guest.infant.amount,
          }
          
          let total_extra_price = total_extra.adult+total_extra.child+total_extra.infant
          
          let subtotalDate = pricePerDate;
          let finalDate = (pricePerDate+promotionPricePerDate);
          
          if(this.$isNotEmptyV3(guest.price_display)){
            const { price: priceGuest, promotion_price: promotionPriceGuest } = guest.price_display;

            subtotalDate = priceGuest;
            finalDate = (priceGuest+promotionPriceGuest);
          }
          
          if(total_extra_price > 0){
            subtotal += total_extra_price;
            final += total_extra_price;
          }

          subtotal += subtotalDate;
          final += finalDate;

          promotion += promotionPricePerDate;
        }

        return {final,subtotal, promotion}
      },
      generateGuest(guest){
        const GUEST_KEY = [
          {key: 'adult', text: 'Adult', plural: 'Adults'},
          {key: 'child', text: 'Child', plural: 'children'},
          {key: 'infant', text: 'Infant', plural: 'Infant'},
        ];

        const finalGuests = [];
        const { included, extra } = guest;

        GUEST_KEY.forEach(gst => {
          const { key, text, plural } = gst;
          const totalGuest = Number(included[key]) + Number(extra[key]);
          if(totalGuest > 0){
            const guestText = `${totalGuest} ${totalGuest > 1 ? plural : text}`;
            finalGuests.push(guestText);
          }
        });

        return this.$isNotEmptyV2(finalGuests) ? finalGuests.join(', ') : ""
      },
      filterProductByRouteType(products){
        const getProductsByRoute = (key) => {
          return products.filter(prd => {
            const { cm_transport_route_type: routeType } = prd.data;
            return routeType === key || routeType === 'ROUNDTRIP';
          });
        };
        
        let routeTypeList = [];
        
        const pickupProducts = getProductsByRoute('PICKUP');
        const dropoffProducts = getProductsByRoute('DROPOFF');

        if(pickupProducts.length > 0) routeTypeList.push({ code: 'PICKUP', title: 'Pickup', data: pickupProducts })
        if(dropoffProducts.length > 0) routeTypeList.push({ code: 'DROPOFF', title: 'Dropoff', data: dropoffProducts })
        
        return routeTypeList;
      },
      removeReservation(roomData){
        const { 
          roomQty,
          guestIndex,
          room_rate: { 
            id: roomId,
            room_type:{ id: roomTypeId, is_virtual, availability_affected }
          }
        } = roomData;
        this.BeRemoveReservation({ roomId, guestIndex });

        let roomtype_params = {
          id: roomTypeId,
          rr_id: roomId,
          qty: roomQty,
          action: 'inc',
          is_virtual,
          availability_affected
        }
        this.changeBeRoomAvbl(roomtype_params);
      },
      manageGuest(roomIndex, guestIndex){
        let selectedRoom = this.$deepCopy(this.getBeCart.room_rate_details[roomIndex]);
        Object.assign(selectedRoom, { guestIndex })
        this.$emit('adjustPax', selectedRoom);
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/be/PerRoomCart.vue